import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import GlobalLockModal from './globallockmodal';
import MasterPassword from './masterpassword';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import Modal from '../../components/modal';

import {
  fetchSecurity,
} from '../../actions';

class GlobalLock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      newPassword: '',
      modalComponent: null,
      wideModal: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchSecurity());
  }

  toggleModal(component, wideModal) {
    this.setState({
      modalComponent: component,
      wideModal: wideModal,
    });
  }

  render() {
    const { user, errors, success } = this.props;
    const { password, newPassword } = this.state;

    let masterEnabled;
    if (user && user.me && user.me.flags && user.me.flags.masterPasswordSet) {
      masterEnabled = user.me.flags.masterPasswordSet;
    }

    let otpEnabled;
    let yubiEnabled;
    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    let enabled2fa;
    if (otpEnabled || yubiEnabled) {
      enabled2fa = true;
    }

    let globalSettingsLock;
    if (user && user.me && user.me.flags && user.me.flags.globalSettingsLock) {
      globalSettingsLock = user.me.flags.globalSettingsLock;
    }

    if (!user.security) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    return (
      <div className="grid-x">
        <ToastHandler errors={errors} success={success} />
        {this.state.modalComponent &&
          <Modal noclose={user.resetCode} toggleModal={this.toggleModal} modalComponent={this.state.modalComponent} wideModal={this.state.wideModal} />
        }
        <div className="cell small-12 medium-12 large-12" style={{marginBottom: 20}}>
          <a className="backlink" href="/settings">
            <FontAwesomeIcon
              size="sm"
              icon={faChevronLeft}
            />
            &nbsp;
            Back to Settings
          </a>
        </div>
        <div className="cell panel v2 small-12 medium-12 large-12">
          <div className="panel-label">
            Global Lock
          </div>
          <p className="mute">
            Enabling this will lock your account. All functionality will be disabled except for login and deposit.
          </p>
          <hr />
          <div className="grid-x align-middle">
            <div className="cell small-6 medium-6 large-6">
              <div>Master Password</div>
            </div>
            <div className="cell small-6 medium-6 large-6 flex-end">
              <button
                className="vlt-btn vlt-btn-outline"
                type="button"
                onClick={() => this.toggleModal(
                  <MasterPassword
                    toggleModal={this.toggleModal}
                    modalComponent={this.state.modalComponent}
                  />,
                )}
                disabled={!enabled2fa}
              >
                <span>
                  {masterEnabled ? (
                    'Reset Master Password'
                  ) : (
                    'Enable Master Password'
                  )}
                </span>
              </button>
              {!enabled2fa && (
                <div style={{ marginTop: 20 }}>
                  <small>Requires 2FA enabled</small>
                </div>
              )}
            </div>
          </div>
          <hr />
          <div className="grid-x align-middle">
            <div className="cell small-6 medium-6 large-6">
              Global Lock
            </div>
            <div className="cell small-6 medium-6 large-6 flex-end">
              {!enabled2fa ? (
                <div
                  className={globalSettingsLock ? 'vlt-switch on' : 'vlt-switch off'}
                  disabled
                >
                  <div></div>
                  <div></div>
                </div>
              ) : (
                <div
                  className={globalSettingsLock ? 'vlt-switch on' : 'vlt-switch off'}
                  onClick={() => this.toggleModal(
                    <GlobalLockModal
                      toggleModal={this.toggleModal}
                      modalComponent={this.state.modalComponent}
                    />,
                  )}
                >
                  <div></div>
                  <div></div>
                </div>
              )}
              {!enabled2fa && (
                <div style={{ marginTop: 20 }}>
                  <small>Requires 2FA enabled</small>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  success: state.user.success,
});

export default connect(mapStateToProps)(GlobalLock);
